export interface LoginUser {
  email: string;
  password: string;
  username?: string;
}

export interface LocalUser extends LoginUser {
  access_token?: string;
  accountType: AccountType;
  currentIdentityProvider: IdentityProvider;
  identityProviderToken?: string;
  lastLogin: Date;
}

export enum Role {
  User = 'user',
  Trainer = 'trainer',
  Admin = 'admin',
}

export enum AccountType {
  'basic',
  'premium',
}

export enum IdentityProvider {
  'google',
  'apple',
  'email',
}
